<template>
  <div>


    <template v-if="context.parent && context.parent.tag==='subForm'">
      <!-- 日期格式 -->
      <el-date-picker v-if="type==='fill' && element.attrs.format!=='HH:mm'" placeholder="请设置"
                      v-model="data[element.id]"
                      :type="getType" :disabled-date="disabledDate"
                      :format="element.attrs.format" :value-format="element.attrs.format" style="width: 100%">
      </el-date-picker>
      <!-- 时间格式 -->
      <el-time-picker v-else-if="type==='fill' && element.attrs.format==='HH:mm'" v-model="data[element.id]"
                      placeholder="请设置"
                      :format="element.attrs.format" :value-format="element.attrs.format" style="width: 100%"/>

      <div v-else-if="type==='detail'">{{ data[element.id] }}</div>
    </template>

    <el-form-item v-else :required="context.authentication.isRequired(element)">
      <template #label>
      <span :style="{color:'#344262','font-weight':context.form.setting.style.PC.title}">
        {{ element.label }}
        <form-element-tooltip :element="element"></form-element-tooltip>
      </span>
      </template>
      <!-- 日期格式 -->
      <el-date-picker v-if="type==='fill' && element.attrs.format!=='HH:mm'" placeholder="请设置"
                      v-model="data[element.id]"
                      :type="getType" :disabled-date="disabledDate"
                      :format="element.attrs.format" :value-format="element.attrs.format" style="width: 100%">
      </el-date-picker>
      <!-- 时间格式 -->
      <el-time-picker v-else-if="type==='fill' && element.attrs.format==='HH:mm'" v-model="data[element.id]"
                      placeholder="请设置"
                      :format="element.attrs.format" :value-format="element.attrs.format" style="width: 100%"/>

      <div v-else-if="type==='detail'" class="design-detail">{{ data[element.id] || "⠀" }}</div>
    </el-form-item>

  </div>
</template>

<script>

import {mapStores} from "pinia";
import {useFlowStore} from "@/stores/flow";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";
import {dynamicFunction} from "@/pojo/script";
import {useFormStore} from "@/stores/form";
import {debounce} from "lodash";

export default {
  components: {FormElementTooltip},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapStores(useFlowStore,useFormStore),
    getType() {
      switch (this.element.attrs.format) {
        case 'YYYY-MM-DD':
          return 'date';
        case 'YYYY-MM':
          return 'month';
        case 'YYYY':
          return 'year';
        case 'YYYY-MM-DD HH:mm':
          return 'datetime';
        case 'YYYY-MM-DD HH:mm:ss':
          return 'datetime';
      }

      return '';
    }
  },
  data() {
    return {
      data: {},
      type: '',
      debouncedHandler: debounce((newValue, oldValue) => {
        try {
          this.data[this.element.id] = dynamicFunction(this.element.default.script.value, {...this.data,...(this.context.rawData || {})});        } catch (e) {
          console.error(this.element.default.script.value, e)
        }
      }, 100),
    }
  },
  created() {
    this.data = this.context.data;
    this.type = this.flowStore.typeOfElement(this.element, this.context);

    if (this.type === 'fill' && !this.data[this.element.id] && this.element.default.select === 'today') {
      this.data[this.element.id] = this.current(this.element.attrs.format);
    }
  },
  mounted() {
    this.initWatch();
  },
  unmounted() {
    if ( this.element.default?.script?.value)
      this.debouncedHandler();
  },
  methods: {
    initWatch() {

      let columns = this.formStore.columnsFlatMap(this.context.form);

      if (this.type === 'fill' && this.element.default.select === 'script' && this.element.default.script.value.length > 0) {

        if (!this.data[this.element.id] || this.element.default.isAlwaysScript) {
          this.debouncedHandler()
        }

        if (this.context.rawData) {
          Object.keys(this.context.rawData)
              .filter(filter=>filter!==this.element.id)
              .filter(filter => columns.some(some => !some.parent && some.id === filter))
              .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

            this.$watch(`context.rawData.${key}`, this.debouncedHandler, {
              deep: true,
              immediate: false
            });
          });
        }

        Object.keys(this.data)
            .filter(filter=>filter!==this.element.id)
            .filter(filter => columns.some(column =>  column.id === filter))
            .filter(filter => this.element.default.script.value.includes(filter)).forEach(key => {

          this.$watch(`data.${key}`, this.debouncedHandler, {
            deep: true,
            immediate: false
          });
        });
      }


    },
    disabledDate(time) {

      if (this.element.attrs.range === 'week') {
        const today = new Date();
        const dayOfWeek = today.getDay() === 0 ? 7 : today.getDay(); // 周一为1，周日为7
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek); // 计算本周一
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 7); // 计算本周日

        return time.getTime() < startOfWeek.getTime() || time.getTime() > endOfWeek.getTime();
      }else if(this.element.attrs.range === 'month'){
        const today = new Date();
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 本月第一天
        const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 本月最后一天

        return time.getTime() < startOfMonth.getTime() || time.getTime() > endOfMonth.getTime();
      } else {
        return false;
      }
    },
  }
}

</script>

<style scoped lang="scss">

</style>